module.exports = __webpack_public_path__ + "static/media/reg_tabAccount_show.a16d40a5.svg";